export default __webpack_public_path__ + "static/chairbg-a2112afae7d5731e806837da8d878b3c.png";